// WhatsAppFloatingButton.jsx
import React from 'react';

const WhatsAppFloatingButton = () => (
  <a
    href="https://wa.me/+905379236439" // Replace with your WhatsApp number
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg p-4 flex items-center justify-center"
    style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
  >
    <i className="fab fa-whatsapp text-2xl"></i>
  </a>
);

export default WhatsAppFloatingButton;